import React from 'react'
import { useIntl } from 'react-intl'
import { Dropdown } from 'rsuite'
import { usePipelineStore } from '../../../stores/PipelineStore'
import { useDataTableStore } from '../../../stores/DataTableStore'
import { useSettingsStore } from '../../../stores/SettingsStore'

interface BtnActionDropdownPipelineProps {
    setShowAddPipeline: (show: boolean) => void
    setShowFormLogLead: (show: boolean) => void
}

const BtnActionDropdownPipeline = ({ setShowAddPipeline, setShowFormLogLead }: BtnActionDropdownPipelineProps) => {
    const intl = useIntl()
    const { selectMultiPipeline } = usePipelineStore()
    const { tablesData } = useDataTableStore()
    const { settings } = useSettingsStore()
    const disabled = tablesData.pipelinesAbandoned && tablesData.pipelinesAbandoned.length > 0 && settings.pipeline_abandoned_lock

    const renderButton = (props: any, ref: any) => {
        return (
            <button
                {...props}
                ref={ref}
                type='button'
                disabled={disabled}
                className={`btn btn-primary mt-3`}
            >
                <i className="fas fa-plus"></i> {intl.formatMessage({ id: "FORM.ACTION.ADD" })} {selectMultiPipeline.name}
            </button>
        )
    }

    return (
        <Dropdown renderToggle={(props, ref) => renderButton(props, ref)} noCaret placement="bottomEnd">
            <Dropdown.Item
                onClick={() => setShowAddPipeline(true)}
            >
                {intl.formatMessage({ id: "FORM.ACTION.ADD" })} {selectMultiPipeline.name}
            </Dropdown.Item>
            <Dropdown.Item
                onClick={() => setShowFormLogLead(true)}
            >
                {intl.formatMessage({ id: 'FORM.ACTION.ADD_LOGS_IN_BULK' })}
            </Dropdown.Item>
        </Dropdown>

    )
}

export default BtnActionDropdownPipeline